import { Directive } from '@angular/core';

@Directive({
  selector: '[prepPageLayoutHeader],prep-page-layout-header',
  host: {
    class: 'prep-page-layout-header'
  }
})
export class PageLayoutHeaderDirective {

  constructor() { }

}

